import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { postSaveSettings } from '../services/postSaveSettings.service';

export const saveSettings = createAsyncThunk(
  'expensesTracking/saveSettings',
  async (data, { getState }) => {
    const settingsData = data;

    const selectedProjectId = selectSelectedProjectId(getState());
    if (!selectedProjectId) {
      throw new Error('No project id given');
    }

    const expenseTrackingSettingsData = await postSaveSettings(
      selectedProjectId,
      settingsData
    );

    return expenseTrackingSettingsData;
  }
);
